import {
  throttle, indexOf, find, isEmpty,
} from 'lodash';

// eslint-disable-next-line import/no-extraneous-dependencies
import mainApi from 'api';
import {
  C_CLOSE_CLASSIFIED_ACTIVITY_TIMEOUT,
  C_TIME_OUT_CRM_MESSAGES,
  C_NUMBER_DISPATCH_CRM_MESSAGES,
} from 'src/store/modules/app';
import { focused } from 'src/store/modules/home';
import {
  notice as channels, commandType, toast,
  channelType, crmMessages, inputMessages,
} from 'src/utils';
import consts from 'src/utils/consts';
import { parseActivity } from 'api/getActivity';
import i18n from 'src/features/i18n';
import notificationsRegister from 'src/utils/notificationsRegister';
import { l } from 'src/utils/helper';

import {
  ADD_ACTIVITY,
  REMOVE_ACTIVITY,
  UPDATE_META_DATA_FOR_ACTIVITY,
  PUT_ACTIVITY_AT_THE_END_OF_ACTIVITIES_LIST,
} from 'src/store/modules/agent';
import {
  getActivityById,
  fetchActivity,
  updateAppeal,
  CREATE_BLANK_ACTIVITY,
  UPDATE_ACTIVITY,
  ACTIVITY_MESSAGE_ADD,
  APPEAL_STATUS_REMOVE,
  CLEAR_INPUT_ATTACHMENTS,
  SET_ACTIVITY_LOADED,
} from 'src/store/modules/activities';
import { isExternalOperator } from 'src/store/modules/user';

export const SET_OPERATORS_FOR_CURRENT_OPERATOR = 'SET_OPERATORS_FOR_CURRENT_OPERATOR';

const stateData = {
  operatorSearchResults: [],
  newOutboundActivityId: null,
  selectedActivity: null,
  requestTypesByTeam: [],
};

const MAXIMUM_ADD_ACTIVITY_ATTEMPTION_COUNT = 4;
const ADD_ACTIVITY_ATTEMPTION_TIMEOUT = 1000;
const DEV_MODE = process.env.NODE_ENV === 'development';

const attachmentErrorInfoMessage = ({ data, activityId, id }) => ({
  activityId,
  id,
  message: data.infoMessageText,
  username: 'СИСТЕМА',
  date: new Date(),
  insertedAt: new Date(),
  isRead: true,
  sender: 'info_message',
});

function subscribeToActivity(dispatch, activityId) {
  const channelTypeName = channelType.ROOM;
  dispatch('home/subscribe', {
    resourceId: activityId,
    channelTypeName,
  }, {
    root: true,
  });
}

function unSubscribeToActivity(activityId) {
  channels.unSubscribe(activityId, channelType.ROOM);
}

function sendPushNotification(activity, rootGetters, rootState) {
  const { messages, id } = activity;
  const activityId = id;
  const unreadMessageIndex = messages ? messages
    .findIndex(({ sender, isRead }) => sender !== 'operator' && !isRead) : -1;
  const anyUnreadMessage = unreadMessageIndex !== -1;
  const messageFromCurrentActivity = rootState.agent.selectedActivityId === activityId;

  let notifyMessage = i18n.t('T_NEW_ACTIVITY');

  if (anyUnreadMessage) {
    const index = unreadMessageIndex;
    notifyMessage = messages[index].attachments[0]
      ? messages[index].attachments[0].title : messages[index].message;

    if (rootGetters[`home/${focused}`]) {
      if (!messageFromCurrentActivity && rootState.agent.selectedActivityId) {
        toast.message({
          title: i18n.t('T_NEW_MESSAGE'),
          msg: notifyMessage,
          duration: consts.TOAST_NOTIFICATION_DURATION,
        });
      }
    } else {
      notificationsRegister(notifyMessage);
    }
  }
}

function sendSoundAndTitleNotification(activity, rootGetters, rootState, dispatch) {
  const messageFromCurrentActivity = rootState.agent.selectedActivityId === activity.id;
  if (!rootGetters[`home/${focused}`] || !messageFromCurrentActivity) {
    dispatch('home/startAutoChangeTitle', i18n.t('T_NEW_MESSAGE'), { root: true });
    dispatch('home/newMessagePlaySound', {}, { root: true });
  }
}

function handleAddedOutboundActivity(commit, params) {
  if (params.activity.outbound) {
    commit('SET_NEW_OUTBOUND_ACTIVITY', params.activity.id);
  }
}

async function addActivity(params, attemption) {
  if (attemption >= MAXIMUM_ADD_ACTIVITY_ATTEMPTION_COUNT) return false;
  const {
    commit,
    dispatch,
    rootState,
    rootGetters,
    activity,
  } = params;
  const activityId = activity.id;
  const { previousActivity } = activity;
  const channelsList = await dispatch('home/channels', {}, { root: true });
  if (channelsList().get(`room:${activityId}`) && channelsList().get(`room:${activityId}`).state === 'joined') {
    if (indexOf(rootState.agent.activities, activityId) === -1) {
      const getActivity = rootGetters[`activities/${getActivityById}`];
      const { customerOnline, isAuthorized, noAuthorized } = getActivity(activityId);

      commit(`agent/${ADD_ACTIVITY}`, activityId, { root: true });
      commit(`agent/${UPDATE_META_DATA_FOR_ACTIVITY}`, {
        activityId,
        meta: {
          online: customerOnline,
          previous_activity: previousActivity
            || {
              state: '',
              closedBy: '',
              id: undefined,
              appealId: undefined,
            },
          isNew: true,
        },
      }, { root: true });

      if (isAuthorized || noAuthorized) {
        const { customer, channelType: type, appealId } = getActivity(activityId);
        let existSiebel = {}; // для теста с CRM
        if (DEV_MODE && isAuthorized) {
          const siebelType = {
            web: '1-5O6FGY',
            email: '1-4NPJI3',
          };
          existSiebel.providerId = siebelType[type]; // для теста с CRM
        } else {
        // const existSiebel = find(customer.accounts, { provider: 'email' }); // для тестирования
          existSiebel = find(customer.accounts, { provider: 'siebel' }); // для прода @prodCRM
        }
        let siebelId; // const siebelId = existSiebel.providerId;

        const isReactIntegration = rootState.app.isFrame && !rootState.home.ucceIntegration;

        if (previousActivity && previousActivity.state === 'transfered' && previousActivity.appealId) {
          if (isReactIntegration) {
            dispatch(`activities/${fetchActivity}`, { id: activityId }, { root: true }).then(() => {
              const previousAppealId = previousActivity.appealId;

              if (previousAppealId && !getActivity(activityId).redirectAppealReceived) {
                siebelId = !isEmpty(existSiebel) ? existSiebel.providerId : null;
                let numberOfDispatch = 0;
                setTimeout(
                  function sendIncomingRedirectAppealMsg() {
                    if (numberOfDispatch < rootState.app[C_NUMBER_DISPATCH_CRM_MESSAGES]) {
                      crmMessages.sendIncomingRedirectAppealMsg(activityId, siebelId, previousAppealId);
                      numberOfDispatch += 1;
                      setTimeout(() => {
                        if (!getActivity(activityId).redirectAppealReceived) sendIncomingRedirectAppealMsg();
                      }, rootState.app[C_TIME_OUT_CRM_MESSAGES]);
                    }
                  },
                );
              }
            });
          } else {
            dispatch(`activities/${updateAppeal}`,
              { activityId, appealId: previousActivity.appealId },
              { root: true });
          }
        } else if (isReactIntegration) {
          dispatch(`activities/${fetchActivity}`, { id: activityId }, { root: true }).then(() => {
            if (!appealId) {
              siebelId = !isEmpty(existSiebel) ? existSiebel.providerId : null;
              let numberOfDispatch = 0;

              setTimeout(
                function sendNewActivity() {
                  if (numberOfDispatch < rootState.app[C_NUMBER_DISPATCH_CRM_MESSAGES]) {
                    crmMessages.sendNewActivity(activityId, siebelId);
                    numberOfDispatch += 1;
                    setTimeout(() => {
                      if (!getActivity(activityId).appealId) sendNewActivity();
                    }, rootState.app[C_TIME_OUT_CRM_MESSAGES]);
                  }
                },
              );
            }
          });
        }
      }
    }
    handleAddedOutboundActivity(commit, params); // для исходящего сообщения оператора нужно переключить фокус
    return true;
  }
  return setTimeout(
    () => addActivity(params, attemption + 1),
    ADD_ACTIVITY_ATTEMPTION_TIMEOUT,
  );
}

function onNewActivity(commit, dispatch, rootState, rootGetters, notice) {
  const activity = parseActivity(JSON.parse(JSON.stringify(notice.activity)));
  const params = {
    commit,
    dispatch,
    rootState,
    rootGetters,
    activity,
  };

  subscribeToActivity(dispatch, activity.id);

  addActivity(params, 0);
}

function onJoinNewActivity(commit, dispatch, rootGetters, rootState, notice) {
  if (notice.data && notice.data.topic.indexOf(channelType.ROOM) !== -1) {
    const activity = parseActivity(JSON.parse(JSON.stringify({ ...notice.data })));
    activity.id = activity.topic.replace(/.+:/, '');
    delete activity.topic;
    const activityId = activity.id;
    const getActivity = rootGetters[`activities/${getActivityById}`];
    const messagesFromOperator = activity.messages
      .filter((msg) => msg.activityId === activityId && msg.sender === 'operator' && !msg.auto);
    const isNewActivity = messagesFromOperator.length === 0;

    commit(`agent/${UPDATE_META_DATA_FOR_ACTIVITY}`, {
      activityId,
      meta: { online: activity.customer.online, inputText: '', isNew: isNewActivity },
    }, { root: true });

    if (typeof getActivity(activityId) === 'undefined') {
      commit(`activities/${CREATE_BLANK_ACTIVITY}`, { id: activityId }, { root: true });
    } else {
      commit(`agent/${UPDATE_META_DATA_FOR_ACTIVITY}`, {
        activityId,
        meta: { onHold: getActivity(activityId).state === 'on_hold' }, // мета при перезагрузке страницы
      }, { root: true });
    }

    commit(`activities/${UPDATE_ACTIVITY}`, {
      activity: getActivity(activityId),
      response: activity,
    }, { root: true });

    sendSoundAndTitleNotification(activity, rootGetters, rootState, dispatch);
    sendPushNotification(activity, rootGetters, rootState);
    dispatch(`activities/${fetchActivity}`, { id: activityId }, { root: true });
  }
}

function onlineInActivityUpdate(commit, activity, changes, online, stateType, onlineAt) {
  Object.keys(changes).forEach((key) => {
    if (key.indexOf('customer') === 0) {
      const customerId = key.replace('customer:', '');
      const activityId = activity.id;
      const newOnlineAt = changes[key].metas[0] ? changes[key].metas[0].onlineAt : undefined;
      if ((typeof onlineAt === 'undefined') || (onlineAt <= newOnlineAt)) {
        commit(`agent/${UPDATE_META_DATA_FOR_ACTIVITY}`, {
          activityId,
          meta: { onlineAt: newOnlineAt },
        }, { root: true });
        if (customerId && stateType === 'meta') {
          commit(`agent/${UPDATE_META_DATA_FOR_ACTIVITY}`, {
            activityId,
            meta: { online },
          }, { root: true });
        } else if (customerId && stateType === 'activities') {
          commit(`activities/${UPDATE_ACTIVITY}`, {
            activity,
            response: { customerOnline: online },
          }, { root: true });
        }
      }
    }
  });
}

function onPresenceState(commit, rootState, rootGetters, notice) {
  const { activityId } = notice;
  const getActivity = rootGetters[`activities/${getActivityById}`];
  const onlineAt = rootState.agent.meta[activityId]
    ? rootState.agent.meta[activityId].onlineAt : undefined;
  if (indexOf(rootState.agent.activities, activityId) !== -1) {
    onlineInActivityUpdate(commit, activityId, notice.body, true, 'meta', onlineAt);
  } else if (typeof getActivity(activityId) !== 'undefined') {
    onlineInActivityUpdate(commit, getActivity(activityId), notice.body, true, 'activities', onlineAt);
  }
}

function onPresenceDiff(commit, rootState, rootGetters, notice) {
  const { activityId } = notice;
  const getActivity = rootGetters[`activities/${getActivityById}`];
  const onlineAt = rootState.agent.meta[activityId]
    ? rootState.agent.meta[activityId].onlineAt : undefined;
  if (indexOf(rootState.agent.activities, activityId) !== -1) {
    onlineInActivityUpdate(commit, { id: activityId }, notice.leaves, false, 'meta', onlineAt);
    onlineInActivityUpdate(commit, { id: activityId }, notice.joins, true, 'meta', onlineAt);
  } else if (typeof getActivity(activityId) !== 'undefined') {
    onlineInActivityUpdate(commit, getActivity(activityId), notice.joins, true, 'activities', onlineAt);
  }
}

function onInputText(commit, activityId, value) {
  commit(`agent/${UPDATE_META_DATA_FOR_ACTIVITY}`, {
    activityId,
    meta: { inputText: value },
  }, { root: true });
}

// обработка полученного события is_typing (другая сторона диалога печатает)
// производится не чаще чем раз в throttleTimeForReceiveTypingHandler
const throttleTimeForReceiveTypingHandler = 1000;

// через typingPrintTime c момента последней обработки события `is_typing`
// прекратится отображение "печатания" другой стороной диалога в UI
const typingPrintTime = 1500;

const typingActivityTimers = {};

function setTypingOff(commit, activityId) {
  clearTimeout(typingActivityTimers[activityId]);
  typingActivityTimers[activityId] = setTimeout(() => {
    commit(`agent/${UPDATE_META_DATA_FOR_ACTIVITY}`, {
      activityId,
      meta: { typing: false },
    }, { root: true });
    delete typingActivityTimers[activityId];
  }, typingPrintTime);
}

function setTypingOn(commit, activityId) {
  commit(`agent/${UPDATE_META_DATA_FOR_ACTIVITY}`, {
    activityId,
    meta: { typing: true },
  }, { root: true });

  setTypingOff(commit, activityId);
}

const onReceiveTypingEvt = throttle(setTypingOn, throttleTimeForReceiveTypingHandler);

function onCloseAfterSeconds({ commit }, activityId, seconds) {
  commit(`agent/${UPDATE_META_DATA_FOR_ACTIVITY}`, {
    activityId,
    meta: { autoClose: { seconds } },
  }, { root: true });
}

function onPreCloseAfterSeconds({ commit }, activityId, seconds) {
  commit(`agent/${UPDATE_META_DATA_FOR_ACTIVITY}`, {
    activityId,
    meta: { preClose: { seconds } },
  }, { root: true });
}

function onPreHoldAfterSeconds({ commit }, activityId, seconds) {
  commit(`agent/${UPDATE_META_DATA_FOR_ACTIVITY}`, {
    activityId,
    meta: { preHold: { seconds } },
  }, { root: true });
}

function sendActivityDirectories(commit, rootState, activityId, appealId, directories) {
  let numberOfDispatch = 0;

  setTimeout(
    function sendMessageActivityDirectories() {
      if (numberOfDispatch < rootState.app[C_NUMBER_DISPATCH_CRM_MESSAGES]) {
        crmMessages.sendActivityDirectories(activityId, appealId, directories);
        numberOfDispatch += 1;
        setTimeout(() => {
          const { appealIsClosed } = rootState.activities;
          if (appealIsClosed.indexOf(activityId) === -1) {
            sendMessageActivityDirectories();
          } else {
            commit(`activities/${APPEAL_STATUS_REMOVE}`, { activityId }, { root: true });
          }
        }, rootState.app[C_TIME_OUT_CRM_MESSAGES]);
      }
    },
  );
}

async function onLeft(commit, rootGetters, rootState, dispatch, activityId) {
  const getActivity = rootGetters[`activities/${getActivityById}`];
  if (typeof getActivity(activityId) === 'undefined'
    || typeof rootState.agent.meta[activityId] === 'undefined') {
    l.error(`onLeft activity error. Activity not found. Activity Id is ${activityId}.`);
    return;
  }
  const {
    markers, appealId, isAuthorized, noAuthorized,
  } = getActivity(activityId);
  const { isClosed, isLeft } = rootState.agent.meta[activityId];
  const timeLiveClosedAcivity = rootState.app[C_CLOSE_CLASSIFIED_ACTIVITY_TIMEOUT];

  if (isLeft) return;

  const directories = markers && markers.length ? markers.map((item) => ({
    level1Code: item.directory.name,
    level1Id: item.directory.id,
    level2Code: item.name,
    level2Id: item.id,
  })) : [];

  if (!isEmpty(appealId) && rootState.app.isFrame && (isAuthorized || noAuthorized)
    && !rootState.home.ucceIntegration) {
    sendActivityDirectories(commit, rootState, activityId, appealId, directories);
  }

  commit(`agent/${UPDATE_META_DATA_FOR_ACTIVITY}`, {
    activityId,
    meta: {
      online: false,
      isClosed: true,
      autoClose: false,
      preClose: false,
      preHold: false,
      isLeft: true,
    },
  }, { root: true });

  if (isClosed) {
    //  случай, если оператор закрывает активность(без таймаута)
    dispatch('pushActivityStatistic', { activityId, actionName: 'defocus' });
    channels.unSubscribe(activityId, channelType.ROOM);
    commit(`agent/${REMOVE_ACTIVITY}`, activityId, { root: true });
  } else if (markers && markers.length) {
    // случай, если проставлены маркеры и активность сама закрывается
    setTimeout(() => {
      dispatch('pushActivityStatistic', { activityId, actionName: 'defocus' });
      channels.unSubscribe(activityId, channelType.ROOM);
      commit(`agent/${REMOVE_ACTIVITY}`, activityId, { root: true });
    }, timeLiveClosedAcivity);
  } else {
    //  случай, если клиент закрывает активность(без таймаута)
    channels.unSubscribe(activityId, channelType.ROOM);
    dispatch(`activities/${fetchActivity}`, { id: activityId, force: true }, { root: true });
  }

  if ((rootState.app.isFrame && rootState.home.ucceIntegration)) {
  // TODO: заменить * на ip
    window.parent.postMessage(JSON.stringify({ type: 'closeActivity', data: activityId }), '*');
  }
  inputMessages.remove(activityId);
  commit(`activities/${CLEAR_INPUT_ATTACHMENTS}`, { activityId }, { root: true });
}

function onTransfered(commit, dispatch, rootState, rootGetters, notice) {
  const dataNotice = JSON.parse(JSON.stringify(notice.data));
  const activityId = dataNotice.oldActivityId;
  if (!activityId) return; // hotfix! TODO!! разобраться, почему stop_activity обрабатывается как transfered
  if (channels.isSubscribe(activityId, channelType.ROOM)) {
    unSubscribeToActivity(dispatch, activityId);
  }
  dispatch(`activities/${fetchActivity}`, { id: activityId, force: true }, { root: true }).then(() => {
    commit(`agent/${UPDATE_META_DATA_FOR_ACTIVITY}`, {
      activityId,
      meta: {
        online: false,
        isClosed: true,
        preClose: false,
        preHold: false,
        autoClose: false,
      },
    }, { root: true });
    const getActivity = rootGetters[`activities/${getActivityById}`];
    const {
      customer, appealId, channelType: type, isAuthorized, noAuthorized,
    } = getActivity(activityId);
    const isReactIntegration = rootState.app.isFrame && !rootState.home.ucceIntegration;
    if ((isAuthorized || noAuthorized) && isReactIntegration && !isEmpty(appealId)) {
      let existSiebel = {}; // для теста с CRM
      if (DEV_MODE && isAuthorized) {
        const siebelType = {
          web: '1-5O6FGY',
          email: '1-4NPJI3',
        };
        existSiebel.providerId = siebelType[type]; // для теста с CRM
      } else {
      // const existSiebel = find(customer.accounts, { provider: 'email' }); // для тестирования
        existSiebel = find(customer.accounts, { provider: 'siebel' }); // для прода @prodCRM
      }

      const siebelId = !isEmpty(existSiebel) ? existSiebel.providerId : null;

      crmMessages.sendRedirectAppealMsg(activityId, siebelId, appealId);
    }
  });
  inputMessages.remove(activityId);
  commit(`activities/${CLEAR_INPUT_ATTACHMENTS}`, { activityId }, { root: true });
}

function onHoldActivity(commit, rootGetters, notice) {
  if (notice) {
    const { activityId } = notice;
    const getActivity = rootGetters[`activities/${getActivityById}`];

    if (typeof getActivity(activityId) !== 'undefined') {
      commit(`activities/${SET_ACTIVITY_LOADED}`, {
        activity: getActivity(activityId),
        response: { state: 'on_hold' },
      }, { root: true });
      commit(`agent/${PUT_ACTIVITY_AT_THE_END_OF_ACTIVITIES_LIST}`, activityId, { root: true });
      // убираем отображение таймера preHold (если был)
      commit(`agent/${UPDATE_META_DATA_FOR_ACTIVITY}`, {
        activityId,
        meta: { preHold: false },
      }, { root: true });
    } else {
      l.error(`Holding activity error. Activity not found. Activity Id is  ${activityId}`);
    }
  } else {
    l.error('Holding activity error. No notice info');
  }
}

function onAttachmentError(commit, rootGetters, notice) {
  const { activityId } = notice;
  const getActivity = rootGetters[`activities/${getActivityById}`];
  const messageParams = attachmentErrorInfoMessage(notice);
  commit(`activities/${ACTIVITY_MESSAGE_ADD}`, {
    activity: getActivity(activityId),
    message: messageParams,
  }, { root: true });
}

const actions = {
  async operatorsForCurrentOperatorSearch({ commit }, id) {
    try {
      const operators = await mainApi.getOperatorsForCurrentOperatorSearch({ id });
      commit('SET_OPERATORS_FOR_CURRENT_OPERATOR', operators);
    } catch (error) {
      l.error(error);
    }
  },
  subscribeToRoomChannels({ dispatch }, activities) {
    activities.forEach((activity) => {
      if (activity.state !== 'closed' && activity.state !== 'transfered') {
        subscribeToActivity(dispatch, activity.id);
      }
    });
  },
  unSubscribeToRoomChannels({ dispatch }, activities) {
    activities.forEach((activity) => {
      unSubscribeToActivity(dispatch, activity.id);
    });
  },
  getOpenCases({ rootGetters }, clientId) {
    const isExternalOperatorVal = rootGetters[`user/${isExternalOperator}`];
    return mainApi.getCustomer(clientId, isExternalOperatorVal).then((res) => res.cases);
  },
  getAllRequestTypes(_, payload = {
    onlyActive: false,
  }) {
    return mainApi.getAllRequestTypes(payload).then((res) => res);
  },
  hideActivity({ commit, dispatch }, activityId) {
    dispatch('pushActivityStatistic', { activityId, actionName: 'defocus' });
    commit(`agent/${REMOVE_ACTIVITY}`, activityId, { root: true });
  },
  pushDefocusAndUpdateMetaOnClose({ commit, dispatch }, activityId) {
    dispatch('pushActivityStatistic', { activityId, actionName: 'defocus' });
    commit(`agent/${UPDATE_META_DATA_FOR_ACTIVITY}`, {
      activityId,
      meta: { isClosed: true },
    }, { root: true });
  },
  pushUserAction({ commit }, { activityId, actionName = '' }) {
    if (channels.isSubscribe(activityId, channelType.ROOM)) {
      channels.push(activityId, commandType.ACTION, { name: actionName });
      commit(`agent/${UPDATE_META_DATA_FOR_ACTIVITY}`, {
        activityId,
        meta: { autoClose: false },
      }, { root: true });
    }
  },
  pushActivityStatistic({ rootState }, { activityId, actionName = '' }) {
    const operatorId = rootState.user.id;
    channels.push(operatorId, commandType.ACTION_ACTIVITY, { activityId, name: actionName });
  },
  update({
    commit, state, dispatch, rootGetters, rootState,
  }, notice) {
    switch (notice.type) {
      case commandType.NEW_ACTIVITY:
        onNewActivity(commit, dispatch, rootState, rootGetters, notice);
        break;
      case commandType.STOP_ACTIVITY:
      case commandType.TRANSFERED:
        onTransfered(commit, dispatch, rootState, rootGetters, notice);
        break;
      case commandType.UNABLE_TO_JOIN:
        break;
      case commandType.LEFT:
        onLeft(commit, rootGetters, rootState, dispatch, notice.data.activityId);
        break;
      case commandType.ONHOLD_ACTIVITY:
        onHoldActivity(commit, rootGetters, notice);
        break;
      case commandType.JOIN:
        onJoinNewActivity(commit, dispatch, rootGetters, rootState, notice);
        break;
      case commandType.PRESENCE_STATE:
        onPresenceState(commit, rootState, rootGetters, notice);
        break;
      case commandType.PRESENCE_DIFF:
        onPresenceDiff(commit, rootState, rootGetters, notice);
        break;
      case commandType.IS_TYPING:
        if (notice.value) onReceiveTypingEvt(commit, notice.activityId);
        break;
      case commandType.INPUT:
        onInputText(commit, notice.activityId, notice.value);
        break;
      case commandType.INFO:
        if (notice.name === 'notify_inactive_operator') {
          onCloseAfterSeconds({
            commit,
            state,
          }, notice.activityId, notice.data.secondsLeft);
        } else if (notice.name === 'notify_operator_pre_close') {
          onPreCloseAfterSeconds({
            commit,
            state,
          }, notice.activityId, notice.data.secondsLeft);
        } else if (notice.name === 'notify_operator_pre_hold') {
          onPreHoldAfterSeconds({
            commit,
            state,
          }, notice.activityId, notice.data.secondsLeft);
        } else if (notice.name === 'notify_attachment_error') {
          onAttachmentError(commit, rootGetters, notice);
        }
        break;
      default:
        break;
    }
  },
  async fetchActivityById({ commit }, activityId) {
    try {
      const activity = await mainApi.getActivity(activityId);
      commit('SET_SELECTED_ACTIVITY', activity);
    } catch (error) {
      throw error;
    }
  },
  async getRequestTypesByTeam({ commit }, teamId) {
    try {
      const requestTypesByTeam = await mainApi.fetchRequestTypesByTeam(teamId);
      commit('SET_REQUEST_TYPES', requestTypesByTeam);
    } catch (error) {
      throw error;
    }
  },
};

const mutations = {
  SET_OPERATORS_FOR_CURRENT_OPERATOR(state, value) {
    state.operatorSearchResults = value;
  },
  SET_NEW_OUTBOUND_ACTIVITY(state, activityId) {
    if (activityId) {
      state.newOutboundActivityId = activityId;
    }
  },
  SET_SELECTED_ACTIVITY(state, activity) {
    state.selectedActivity = activity;
  },

  SET_REQUEST_TYPES(state, list) {
    state.requestTypesByTeam = list;
  },
};

export default {
  state: stateData,
  mutations,
  actions,
  namespaced: true,
};
